import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  NavParams,
  LoadingController,
  ModalController
} from '@ionic/angular';

import { Client } from '../../models';
import { Country } from '../../models';
import { Salon } from '../../models';
import { Stylist } from '../../models';
import { ClientService } from '../../services/client.service';
import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';
import { CountryService } from '../../services/country.service';
import { CustomValidator } from '../../utilities/custom-validator';
import { ClientEmailChecker } from '../../utilities/client-email-checker';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
declare var posthog: any;
export interface IClientFormCallBackData {
  client: Client;

  // save or delete
  action: string;
}
@Component({
  selector: 'smr-client-form-page',
  templateUrl: './client-form-page.component.html',
  styleUrls: ['./client-form-page.component.scss'],
})
export class ClientFormPageComponent implements OnInit {
  @ViewChild('firstNameInput') firstNameInput;

  public modal: boolean;

  public submitAttempt: boolean;

  @Input() client: Client;

  public salon: Salon;

  public stylist: Stylist;

  public clientForm: UntypedFormGroup;

  public firstName: UntypedFormControl;

  public lastName: UntypedFormControl;
  public pronouns: UntypedFormControl;
  public customPronouns: UntypedFormControl;
  public email: UntypedFormControl;

  public phone1: UntypedFormControl;

  public phone2: UntypedFormControl;

  public workPh: UntypedFormControl;

  public address1: UntypedFormControl;

  public address2: UntypedFormControl;

  public city: UntypedFormControl;

  public province: UntypedFormControl;

  public postal: UntypedFormControl;

  public country: UntypedFormControl;

  public notes: UntypedFormControl;

  public canBookOnline: UntypedFormControl;

  public subscriptionStatus: UntypedFormControl;

  public reminderType: UntypedFormControl;

  public birthdate: UntypedFormControl;

  public clientBirthDate: Date;

  public countries: List<Country>;

  public saveButtonText: string;

  public readOnly: boolean;

  public accountHitMaxClient: boolean;

  public reminderOptions: List<{
    label: string;
    value: string;
    disabled: boolean;
  }>;

  public showMore: boolean = false;
  public pronounOptions: List<{ name: string; value: number }>;
  constructor(
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private actionsheetCtrl: ActionSheetController,
    private clientService: ClientService,
    private userService: UserService,
    private countryService: CountryService,
    private salonService: SalonService,
    private formBuilder: UntypedFormBuilder,
    private loadingCtrl: LoadingController,
    private clientEmailChecker: ClientEmailChecker,
    private modalCtrl: ModalController
  ) {
    this.client = this.navParams.get('client');
    this.modal =
      this.navParams.get('modal') !== undefined
        ? this.navParams.get('modal')
        : false;
    this.stylist =
      this.navParams.get('stylist') !== undefined
        ? this.navParams.get('stylist')
        : this.userService.getUser();

    this.saveButtonText = navParams.get('saveButtonText') || 'Save';
    this.submitAttempt = false;
    this.countries = List([]);

    this.pronounOptions = List.of(
      {
        name: 'Please select',
        value: 0
      },
      {
        name: 'She/Her',
        value: 1
      },
      {
        name: 'He/Him',
        value: 2
      },
      {
        name: 'They/Them',
        value: 3
      },
      {
        name:'Custom',
        value: 4
      }
    );
    // localStorage.setItem('emailCheckerClientID', (this.client.getID()) ? this.client.getID() + '' : 'null');
    this.clientService.setEmailCheckerClientID(
      this.client.getID() ? this.client.getID() : undefined
    );

    this.salon = userService.getSalon().clone();
    const countryID = this.salon.getCountry().id;
    // form controls
    this.firstName = new UntypedFormControl(
      this.client.getFirstName(),
      Validators.compose([Validators.required, Validators.maxLength(30)])
    );
    this.lastName = new UntypedFormControl(
      this.client.getLastName(),
      Validators.maxLength(35)
    );

    this.pronouns = new UntypedFormControl(this.client.getPronouns() ? this.client.getPronouns() : 0);
    this.customPronouns = new UntypedFormControl(
      this.client.getcustomPronouns(),
      Validators.maxLength(35)
    );
    this.email = new UntypedFormControl(
      this.client.getEmail(),
      Validators.compose([
        Validators.maxLength(100),
        CustomValidator.validateEmail,
      ]),
      this.clientEmailChecker.clientEmailAvailabilityChecker()
    );
    this.phone1 = new UntypedFormControl(
      this.client.getPhone1(),
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID)
      ])
    );
    this.phone2 = new UntypedFormControl(
      this.client.getPhone2(),
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID)
      ])
    );
    this.workPh = new UntypedFormControl(
      this.client.getWorkph(),
      Validators.maxLength(20)
    );
    this.address1 = new UntypedFormControl(
      this.client.getAddress1(),
      Validators.maxLength(40)
    );
    this.address2 = new UntypedFormControl(
      this.client.getAddress2(),
      Validators.maxLength(40)
    );
    this.city = new UntypedFormControl(
      this.client.getCity(),
      Validators.maxLength(20)
    );
    this.province = new UntypedFormControl(
      this.client.getProvince(),
      Validators.maxLength(25)
    );
    this.postal = new UntypedFormControl(
      this.client.getPostal(),
      Validators.maxLength(25)
    );
    this.country = new UntypedFormControl(
      this.client.getCountry() !== undefined
        ? this.client.getCountry().getID()
        : null
    );
    this.notes = new UntypedFormControl(this.client.getNotes());
    this.canBookOnline = new UntypedFormControl(
      this.client.isBlockedOnline() === false
    );
    this.subscriptionStatus = new UntypedFormControl(
      this.client.isUnsubscribed() === false
    );
    this.reminderType = new UntypedFormControl(
      this.client.reminderType ? this.client.reminderType : '4'
    );
    this.birthdate = new UntypedFormControl(
      this.client.getBirthDate()
        ? Utilities.formatDate(this.client.getBirthDate(), 'Y-MM-DD')
        : undefined
    );
    this.clientBirthDate = this.client.getBirthDate();
    this.clientForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
      pronouns: this.pronouns,
      customPronouns: this.customPronouns,
      email: this.email,
      phone1: this.phone1,
      phone2: this.phone2,
      workPh: this.workPh,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal: this.postal,
      country: this.country,
      notes: this.notes,
      canBookOnline: this.canBookOnline,
      subscriptionStatus: this.subscriptionStatus,
      reminderType: this.reminderType,
      birthdate: this.birthdate,
    });
    this.readOnly = this.userService.getSalon().readOnly === 1;
    this.refreshReminderOptions();
  }

  public ngOnInit() {
    this.checkMaxClientLimit();

    this.countryService.getCountries().subscribe({
      next: (countries) => {
        this.countries = countries;
      },
      error: async (error) => {
        const alert = await this.alertCtrl.create(
          Utilities.getDefaultErrorMessageConfig()
        );
        alert.present();
      },
    });
  }

  public refreshReminderOptions() {
    this.reminderOptions = List([]);
    const hasEmail: boolean = this.hasEmail();
    const hasPhone2: boolean = this.hasPhone2();

    this.reminderOptions = this.reminderOptions.push({
      label: 'Email',
      value: '1',
      disabled: !hasEmail,
    });

    this.reminderOptions = this.reminderOptions.push({
      label: 'SMS',
      value: '2',
      disabled: !hasPhone2,
    });

    this.reminderOptions = this.reminderOptions.push({
      label: 'Email + SMS',
      value: '3',
      disabled: !(hasEmail && hasPhone2),
    });

    this.reminderOptions = this.reminderOptions.push({
      label: 'None',
      value: '4',
      disabled: false,
    });
  }

  public hasEmail(): boolean {
    return (
      this.email.value !== undefined &&
      CustomValidator.isEmailValid(this.email.value)
    );
  }

  public hasPhone2(): boolean {
    return (
      this.phone2.value !== undefined &&
      CustomValidator.isPhoneValid(this.phone2.value)
    );
  }

  public onEmailChange($event) {
    this.refreshReminderOptions();

    // check if creating a NEW client
    if (this.client.id === undefined) {
      const hasEmail: boolean = this.hasEmail();
      const hasPhone2: boolean = this.hasPhone2();

      // "auto-set" reminderType when a new user is being created.
      if (hasEmail) {
        // If the remind by HAS NO VALUE yet and when an email is entered then set the remind-by to "email"
        if (this.reminderType.value === '4') {
          this.reminderType.setValue('1');
        }
      } else {
        // check if reminderType is `Email` or `Email + SMS`
        if (
          this.reminderType.value === '1' ||
          this.reminderType.value === '3'
        ) {
          if (hasPhone2) {
            // auto set to SMS
            this.reminderType.setValue('2');
          } else {
            // set to None
            this.reminderType.setValue('4');
          }
        }
      }
    }
  }

  public onPhone2Change($event) {
    this.refreshReminderOptions();

    // check if creating a NEW client
    if (this.client.id === undefined) {
      const hasEmail: boolean = this.hasEmail();
      const hasPhone2: boolean = this.hasPhone2();

      // "auto-set" reminderType when a new user is being created.
      if (hasPhone2) {
        // If the remind by HAS NO VALUE yet and when an email is entered then set the remind-by to "email"
        if (this.reminderType.value === '4') {
          this.reminderType.setValue('2');
        }
      } else {
        // check if reminderType is `SMS` or `Email + SMS`
        if (
          this.reminderType.value === '2' ||
          this.reminderType.value === '3'
        ) {
          if (hasEmail) {
            // auto set to Email
            this.reminderType.setValue('1');
          } else {
            // set to None
            this.reminderType.setValue('4');
          }
        }
      }
    }
  }

  public async checkMaxClientLimit() {
    // check if the salon is under a free plan
    if (this.userService.getSalon().planID !== 1) {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();
    this.salonService.getClientsCount().subscribe({
      next: (count: number) => {
        loader.dismiss().then(() => {
          if (count >= 50) {
            this.accountHitMaxClient = true;
          }
        });
      },
      error: (err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  public onDismiss() {
    this.modalCtrl.dismiss();
  }

  public async onClientSave() {
    this.submitAttempt = true;

    if (this.clientForm.valid === false) {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    // update client data
    let newCountry: Country;
    this.countries
      .filter((country: Country) => country.getID() === this.country.value)
      .map((country: Country) => {
        newCountry = country;
      });



    this.client = this.client.setFirstName(this.firstName.value);
    this.client = this.client.setLastName(this.lastName.value);
    this.client = this.client.setPronouns(this.pronouns.value);
    this.client = this.client.setcustomPronouns(this.customPronouns.value);
    this.client = this.client.setEmail(this.email.value);
    this.client = this.client.setPhone1(this.phone1.value);
    this.client = this.client.setPhone2(this.phone2.value);
    this.client = this.client.setWorkPh(this.workPh.value);
    this.client = this.client.setAddress1(this.address1.value);
    this.client = this.client.setAddress2(this.address2.value);
    this.client = this.client.setCity(this.city.value);
    this.client = this.client.setProvince(this.province.value);
    this.client = this.client.setPostal(this.postal.value);
    this.client = this.client.setCountry(newCountry);
    this.client = this.client.setNotes(this.notes.value);
    this.client = this.client.setSalonID(this.userService.getSalon().id);
    this.client = this.client.setStylistID(this.stylist.id ? this.stylist.id : this.userService.getUser().id);
    this.client = this.client.setBlockedOnline(
      this.canBookOnline.value === false
    );
    this.client = this.client.setUnsubscribed(
      this.subscriptionStatus.value === false
    );
    this.client = this.client.setReminderType(this.reminderType.value);
    this.client = this.client.setBirthDate(this.clientBirthDate);
    this.clientService.saveClient(this.client).subscribe({
      next: (client) => {
        this.client = client;

        const data: IClientFormCallBackData = {
          client: this.client,
          action: 'save',
        };

        loader.dismiss().then(() => {
          this.modalCtrl.dismiss(data)
        });
      },
      error: (error) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  public async onClientDelete() {
    const actionSheet = await this.actionsheetCtrl.create({
      header: 'Are you sure you want to delete this client?',
      buttons: [
        {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            const navTransition = actionSheet.dismiss();
            this.clientService.deleteClient(this.client).subscribe({
                next: client => {
                  navTransition.then(() => {
                    const data: IClientFormCallBackData = {
                      client: client,
                      action: 'delete'
                    };
                    this.modalCtrl.dismiss(data);
                  });
                },
                error: async error => {
                  const alert = await this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig())
                  alert.present();
                }
          });
            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    actionSheet.present();
  }

  public onBirthdateChange() {
    // this.birthdate.setValue(birthdate);
    this.clientBirthDate = new Date(this.birthdate.value);
  }

  public onShowMore() {
    this.showMore = !this.showMore;
  }
}
